import React from 'react'
import styled from 'styled-components'

import { fccur, ficur } from '../../helpers/misc'
import { Box, Text } from '../Shared/Base'
import Message from '../Shared/Message'
import LinkSafe from '../Shared/LinkSafe'
import AlertResultContactZone from './Result/ContactZone'
import AlertResultReport from './Result/Report'
import AlertResultTop from './Result/Top'
import { SvgIconGarbage } from '../Shared/Svg/Alert'
import ResultNreTenements from './Result/NreTenements'
import ResultFeatures from './Result/Features'
import ResultTitle from './Result/Title'
import { SvgIconDisabled } from '../Shared/Svg/Alert'
import routes from '../../routes'
import ReactPlayer from 'react-player'
import { AdMap } from './AdMap'

const dpe_colors = {
  A: '#00A774',
  B: '#00BB54',
  C: '#4AC57B',
  D: '#FDEB00',
  E: '#FFBC00',
  F: '#FF882F',
  G: '#EC0118'
}

const ges_colors = {
  A: '#A3DBFC',
  B: '#8AB5D2',
  C: '#7692B1',
  D: '#5E708D',
  E: '#4D5272',
  F: '#393550',
  G: '#291B35'
}

const Nav01 = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.063 5.031a2.813 2.813 0 110 5.625 2.813 2.813 0 010-5.625zm5.02-2.437h-.987a.401.401 0 01-.36-.26c-.464-.978-.944-1.99-1.986-1.99H10c-.803 0-1.227.583-1.994 1.643-.288.395-.383.607-.633.607h-4.5C1.325 2.594 1 3.5 1 4.26v7.791a1.691 1.691 0 001.917 1.792h14.166A1.69 1.69 0 0019 12.052V4.261c0-.76-.332-1.667-1.917-1.667zm-.708 5.25a4.312 4.312 0 11-8.624 0 4.312 4.312 0 018.624 0zM4.75 5.406a.938.938 0 11-1.876 0 .938.938 0 011.876 0zM2.875 1.832l2.25.012a.375.375 0 00.375-.375V1.28C5.5.661 4.996.156 4.375.156h-.75C3.004.156 2.5.66 2.5 1.281v.176c0 .207.168.375.375.375z" />
  </svg>
)

const Nav02 = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.118 14.902a.75.75 0 00-1.045-.175l-.023.02a.188.188 0 01-.296-.15V4.993c0-.121.059-.235.157-.306l3.3-2.354a.188.188 0 01.296.15V6.75a.75.75 0 001.5 0V2.486a.188.188 0 01.297-.15l3.3 2.355a.374.374 0 01.147.303v3.359a.75.75 0 001.5 0V4.608a1.13 1.13 0 00-.471-.916L11.905.21a1.124 1.124 0 00-1.308 0l-4.35 3.109a.375.375 0 01-.45-.009L1.82.241A1.125 1.125 0 000 1.126V12.29c0 .354.167.687.45.9l4.88 3.661c.392.294.93.3 1.329.015l1.285-.918a.75.75 0 00.175-1.046zM1.5 2.271a.188.188 0 01.3-.15l3.3 2.55c.095.07.15.182.15.3v9.57a.188.188 0 01-.3.15l-3.3-2.475a.375.375 0 01-.15-.3V2.27zm16.281 15.51a.75.75 0 000-1.06l-1.795-1.795a.376.376 0 01-.058-.456 4.132 4.132 0 10-1.46 1.46.376.376 0 01.456.057l1.797 1.796a.75.75 0 001.06 0v-.001zm-8.03-5.405a2.625 2.625 0 115.25 0 2.625 2.625 0 01-5.25 0z" />
  </svg>
)

const Nav03 = () => (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.897.732a1.843 1.843 0 110 3.685 1.843 1.843 0 010-3.685zm1.615 7.664a6.28 6.28 0 001.783.933l.867.289a1.105 1.105 0 001.443-.883A1.143 1.143 0 009.807 7.5l-.815-.27a4.067 4.067 0 01-1.153-.605l-.749-.561a4.202 4.202 0 00-4.396-.398A4.658 4.658 0 00.106 9.773a1.107 1.107 0 001.106 1.19c.59 0 1.077-.463 1.106-1.052a2.515 2.515 0 011.195-2.17.185.185 0 01.28.158v1a14.32 14.32 0 01-.34 3.109 9.386 9.386 0 01-1.632 3.465 1.107 1.107 0 001.728 1.38 12.784 12.784 0 001.887-3.913.184.184 0 01.32-.06 12.248 12.248 0 011.78 3.632 1.105 1.105 0 102.099-.7v-.002a12.675 12.675 0 00-3.368-5.542.732.732 0 01-.262-.556v-1.33a.184.184 0 01.295-.147l.212.16z" />
  </svg>
)

const Check = () => (
  <svg width="13" height="11" fill="none" xmlns="http://www.w3.org/2000/svg" className="check">
    <path
      d="M12.567.217c.478.359.575 1.038.216 1.516l-6.5 8.667a1.083 1.083 0 01-1.632.116L.317 6.183A1.083 1.083 0 011.85 4.65L5.3 8.1 11.05.433a1.083 1.083 0 011.518-.216z"
      fill="#919191"
    />
  </svg>
)

const Tel = () => (
  <Box
    as="svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    mr={10}
  >
    <path
      d="M6.619 8.51a1.5 1.5 0 000-2.121v-.001l-1.592-1.59a1.5 1.5 0 00-2.12 0l-.874.872A2.25 2.25 0 001.75 8.5a34.883 34.883 0 009.75 9.75 2.25 2.25 0 002.83-.284l.873-.873a1.5 1.5 0 000-2.121l-1.591-1.591a1.5 1.5 0 00-2.121 0l-.53.53a35.564 35.564 0 01-4.875-4.875l.533-.526zM10 1.375A8.625 8.625 0 0118.625 10M10 4.375A5.625 5.625 0 0115.625 10M10 7.375A2.625 2.625 0 0112.625 10"
      stroke="#1DA0CA"
    />
  </Box>
)

const BoxNav = styled.nav`
  margin-bottom: 30px;

  ul {
    display: flex;
  }

  li {
    &:not(:last-child) {
      margin-right: 20px;

      @media screen and (max-width: 374px) {
        margin-right: 10px;
      }
    }
  }

  button,
  a {
    border: 1px solid var(--colorThin);
    padding: 8px 16px;
    border-radius: 5px;
    color: var(--colorText);
    display: flex;
    align-items: center;

    @media screen and (max-width: 530px) {
      padding: 8px 10px;
    }

    svg {
      margin-right: 10px;
      fill: var(--colorLight);

      @media screen and (max-width: 530px) {
        display: none;
      }
    }

    &.active {
      border: 1px solid var(--colorPremium);
      color: var(--colorPremium);

      svg {
        fill: var(--colorPremium);
      }
    }
  }
`

const BoxFeatures = styled.ul`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  align-items: center;

  @media screen and (max-width: 620px) {
    grid-template-columns: auto auto;
  }

  @media screen and (max-width: 440px) {
    grid-template-columns: auto;
  }

  @media screen and (min-width: 960px) and (max-width: 1200px) {
    grid-template-columns: auto auto;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      display: flex;
      align-items: center;
    }

    &.disabled {
      color: #dddcdc;
      display: none;

      svg {
        fill: #dddcdc;
      }

      .check {
        opacity: 0;
      }
    }
  }

  svg {
    margin-right: 15px;
    fill: var(--colorText);
  }
`

const BoxVictor = styled(Box)`
  img {
    @media screen and (min-width: 960px) and (max-width: 1180px) {
      display: none;
    }
  }
`

const BlockBottomPremium = ({ ad }) => {
  if (!ad || !ad.ad_premium) return null

  const landlord_agency_costs =
    ad.ad_premium.agency_costs.type === 'const'
      ? ad.ad_premium.agency_costs.amount
      : Math.round(ad.rent * ad.ad_premium.agency_costs.amount)
  return (
    <Box mt={60}>
      <Box
        backgroundColor="premium"
        px={20}
        py="5px"
        borderRadius={5}
        color="white"
        fontSize={14}
        display="inline-block"
        style={{ textTransform: 'uppercase' }}
      >
        Premium
      </Box>
      <Text className="fz-24" mt={10}>
        Logement loué par LouerAgile
      </Text>
      <Text className="fz-16" color="light" mt={10} mb={30}>
        Ce bien est loué par LouerAgile, agence immobilière nouvelle génération. Visite, dossier et
        signature du bail se font en ligne. Visite physique lors de l'état des lieux d'entrée.
        Honoraires de {Math.min(landlord_agency_costs, ad.area * 15)} € TTC à la charge du locataire
        comprenant {ad.area * 3} € pour l'état des lieux.
      </Text>
    </Box>
  )
}

const choices_charges_including = [
  { label: 'Électricité', value: 'electricity' },
  { label: 'Gaz', value: 'gas' },
  { label: 'Ménage', value: 'menage' },
  { label: 'Ordures ménagères', value: 'garbage' },
  { label: 'Gardien', value: 'gardien' },
  { label: 'Eau courante', value: 'water' },
  { label: 'Eau chaude', value: 'hot_water' },
  { label: 'Ascenseur', value: 'lift' },
  { label: 'Entretien Parties Communes', value: 'entretien_partie_commune' },
  { label: 'Piscine', value: 'pool' }
]

const choices_internal_equipments = [
  { label: 'Lave-linge', value: 'll' },
  { label: 'Lave-vaisselle', value: 'lv' },
  { label: 'Four', value: 'oven' },
  { label: 'Cuisine équipée', value: 'cuisine' },
  { label: 'Plaques à induction', value: 'induction' },
  { label: 'Plaques au gaz', value: 'gas' },
  { label: 'Canapé-lit', value: 'sofabed' },
  { label: 'Micro-ondes', value: 'microwaveoven' },
  { label: 'Congélateur', value: 'freezer' }
]

const AdPartnerPres = React.memo(({ ad }) => {
  if (ad.source_description) {
    return (
      <Box
        mt={20}
        px={20}
        py={20}
        borderRadius={10}
        backgroundColor="#EEE"
        display={{ md: 'flex', xs: 'flex' }}
        justifyContent="space-between"
        flexDirection={{ md: 'row', xs: 'column-reverse' }}
      >
        <Box>
          <Box display="flex" flexDirection="row" alignItems="center" mb="5px">
            {ad.source_is_subscribed ? (
              <Text
                as={LinkSafe}
                to={routes.partner_agency.route.reverse({ partner_source: ad.source })}
                fontFamily="Lato_700Bold"
                color="n_tertiary"
                mr={10}
                fontWeight="bold"
              >
                {ad.source_label.toUpperCase()}
              </Text>
            ) : (
              <Text
                as="span"
                fontFamily="Lato_700Bold"
                mr={10}
                fontWeight="bold"
                color="n_tertiary"
              >
                {ad.source_label.toUpperCase()}
              </Text>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={27}
              height={27}
              fill="none"
              viewBox="0 0 27 27"
            >
              <path
                fill="#B361B5"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.087 1.679a1.809 1.809 0 012.826 0l1.679 2.09a1.81 1.81 0 001.607.665l2.665-.29a1.812 1.812 0 011.993 1.996l-.29 2.664a1.812 1.812 0 00.666 1.607l2.089 1.678a1.81 1.81 0 010 2.825l-2.089 1.68a1.807 1.807 0 00-.666 1.606l.29 2.665a1.81 1.81 0 01-1.995 1.995l-2.665-.29a1.813 1.813 0 00-1.607.666l-1.677 2.086a1.808 1.808 0 01-2.826 0l-1.677-2.088a1.812 1.812 0 00-1.607-.667l-2.665.29a1.808 1.808 0 01-1.995-1.995l.29-2.664a1.808 1.808 0 00-.666-1.607l-2.089-1.677a1.81 1.81 0 010-2.825l2.089-1.678a1.81 1.81 0 00.666-1.607l-.29-2.664a1.812 1.812 0 011.995-1.996l2.665.29a1.81 1.81 0 001.607-.665l1.677-2.09z"
              />
              <path
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M17.847 10.785l-4.423 5.896a.833.833 0 01-1.255.09l-2.654-2.654"
              />
            </svg>
          </Box>
          <Text fontSize={16} lineHeight="24px">
            {ad.source_description}
          </Text>
        </Box>
        {ad.source_logo && (
          <Box
            as="img"
            src={ad.source_logo}
            mb={10}
            borderRadius={200}
            flexShrink={1}
            width={50}
            height={50}
          />
        )}
      </Box>
    )
  }

  return null
})

export const AlertResultCL = ({
  ad,
  alert,
  linkBack,
  linkContact,
  onFavorite,
  onUnfavorite,
  onReport
}) => {
  const [navChoice, set_navChoice] = React.useState('photo')
  const [modal_report_open, set_modal_report_open] = React.useState(false)

  const images = ad.images.split(',')
  const is_premium = ad.source === 'loueragile_premium'
  const warn_rent_low =
    ad.rentMinPerM2 && ad.owner_type === 'Particulier' && ad.rentMinPerM2 > ad.rent / ad.area
  const warn_is_spam = ad.nb_spam > 1
  const { description } = ad
  const matches = description.match(/(.*)\. Visite virtuelle disponible ici : (.*)$/s)

  const ad_description = matches ? matches[1] : description
  const latlng = React.useMemo(() => ({ lat: ad.lat, lng: ad.lng }), [ad.lat, ad.lng])

  const has_fb_warning =
    alert &&
    alert.notification_channels &&
    alert.notification_channels.length === 1 &&
    alert.notification_channels[0].type === 'fb'

  const og_url = alert
    ? `${process.env.REACT_APP_API_ENDPOINT}/alert/redirect_preview?token=${alert.id}&ad=${ad.id}`
    : null

  const linkTotal = React.useMemo(
    () => `${process.env.REACT_APP_API_ENDPOINT.replace('/apiv2', '')}${linkContact}`,
    [linkContact]
  )

  const dpe_or_ges_is_bad =
    ad.energy_dpe === 'F' || ad.energy_dpe === 'G' || ad.energy_ges === 'F' || ad.energy_ges === 'G'

  const coduminium_pending_prejudice_text = { false: 'Non', true: 'Oui' }

  return (
    <>
      <AlertResultTop
        navChoice={navChoice}
        images={images}
        linkBack={has_fb_warning ? null : linkBack}
        is_favorite={ad.favorite}
        onFavorite={onFavorite}
        onUnfavorite={onUnfavorite}
        latlng={latlng}
        address={ad.address}
        og_url={og_url}
      />

      {onReport && (
        <AlertResultReport
          modal_open={modal_report_open}
          onReport={onReport}
          onClose={() => set_modal_report_open(false)}
          ad_id={ad.id}
          ad_search_type={ad.search_type}
        />
      )}

      <Box
        maxWidth={1200}
        display={{ md: 'flex', xs: 'block' }}
        justifyContent="space-between"
        mx="auto"
        mt={{ md: 60, xs: 30 }}
        pb={{ md: 100, xs: 150 }}
        px={{ lg: 0, xs: 20 }}
      >
        <Box maxWidth="100%">
          {ad.partner_banner && (
            <Box
              mb={30}
              as={LinkSafe}
              to={{
                pathname: routes.asrenter_partner_generic.route.reverse(),
                state: { partner_banner: ad.partner_banner, alert_id: alert.id }
              }}
              display="block"
            >
              <img
                src={
                  ad.partner_banner.image_url
                    ? ad.partner_banner.image_url.replace('.png', '_desktop.png')
                    : ''
                }
                alt=""
                height={100}
              />
            </Box>
          )}

          {(warn_rent_low || warn_is_spam) && (
            <Message variant="error" className="fz-16" textAlign="left" mt={{ md: 0, xs: '-30px' }}>
              {warn_rent_low && (
                <p>
                  Attention le prix de cette annonce semble très bas par rapport au marché. Il peut
                  s'agir d'une arnaque, soyez vigilant.
                </p>
              )}
              {warn_is_spam && (
                <Box as="p" mt={warn_rent_low ? 10 : 0}>
                  Attention cette annonce a été signalée comme étant une arnaque par plusieurs
                  membres, soyez vigilant.
                </Box>
              )}
            </Message>
          )}

          {is_premium && (
            <BoxNav>
              <ul className="fz-16">
                <li>
                  <button
                    onClick={() => set_navChoice('photo')}
                    className={navChoice === 'photo' ? 'active' : ''}
                  >
                    <Nav01 /> Photos
                  </button>
                </li>
                {Boolean(ad.lat) && Boolean(ad.lng) && (
                  <li>
                    <button
                      onClick={() => set_navChoice('map')}
                      className={navChoice === 'map' ? 'active' : ''}
                    >
                      <Nav02 /> Carte
                    </button>
                  </li>
                )}
                {Boolean(ad.lat) && Boolean(ad.lng) && (
                  <li>
                    <button
                      onClick={() => set_navChoice('streetview')}
                      className={navChoice === 'streetview' ? 'active' : ''}
                    >
                      <Nav03 /> Rue
                    </button>
                  </li>
                )}
              </ul>
            </BoxNav>
          )}

          <ResultTitle ad={ad} />

          {ad.stops && ad.stops.length > 0 && (
            <Box className="fz-16" mt={30}>
              <Text as="h3" className="h3-like">
                Proche des stations
              </Text>
              <Box as="ul" display="flex" flexWrap="wrap">
                {ad.stops.map((stop, i) => (
                  <Box
                    as="li"
                    key={i}
                    mr={10}
                    display="flex"
                    alignItems="center"
                    borderRadius={100}
                    border="1px solid"
                    borderColor="thin"
                    py="5px"
                    px={20}
                    mt={10}
                    className="fz-14"
                  >
                    <span>{stop.name}</span>
                    {stop.lines.map(l => {
                      const img_name = l.replace('Ligne', 'M').replace(' ', '')
                      return (
                        <Box
                          as="img"
                          width={20}
                          ml={10}
                          key={l}
                          alt="metro"
                          src={`https://res.cloudinary.com/loueragile/image/upload/v1558025817/web/icons/subway/${img_name}genRVB.svg`}
                        />
                      )
                    })}
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          <Text
            className="fz-16"
            mt={30}
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
          >
            {ad_description}
          </Text>

          {ad.description_is_truncated && (
            <Box
              as="a"
              href={linkTotal}
              mt={10}
              target="_blank"
              rel="noopener noreferrer"
              color="n_tertiary"
              display="flex"
              alignItems="center"
            >
              <Box as="span" className="fz-16 fls" style={{ textDecorationLine: 'underline' }}>
                Voir plus sur {ad.source_label}
              </Box>
            </Box>
          )}

          {!!ad.webview_link && (
            <Box my={30}>
              {ReactPlayer.canPlay(ad.webview_link) ? (
                <ReactPlayer url={ad.webview_link} light width="100%" controls />
              ) : (
                <Box position="relative" className="resp-container">
                  <Box
                    as="iframe"
                    src={ad.webview_link}
                    frameBorder="0"
                    title="Visite virtuelle"
                    className="resp-iframe"
                    allowFullScreen
                  />
                </Box>
              )}
            </Box>
          )}

          <AdPartnerPres ad={ad} />

          <ResultNreTenements ad={ad} linkContact={linkContact} />
          <ResultFeatures ad={ad} />

          {(ad.features && ad.features.year) || ad.energy_ges || ad.energy_dpe ? (
            <Box borderTop="1px solid" borderWidth="1" borderColor="thin" pt={30} mt={30}>
              {ad.features && ad.features.year ? (
                <Box as="li" mr={30} className="fz-16" mb={10}>
                  Année de construction : {ad.features.year}
                </Box>
              ) : null}
              <Box
                as="ul"
                display={{ sm: 'flex', xs: 'block' }}
                justifyContent="space-between"
                lassName="fz-16"
              >
                {ad.energy_ges && (
                  <>
                    <Box
                      as="li"
                      mr={30}
                      className="fz-16"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      width={{ sm: '50%', xs: '100%' }}
                    >
                      <Box as="span">Indice d'émission de gaz à effet de serre (GES)</Box>
                      <Box
                        as="span"
                        borderRadius={5}
                        px={10}
                        py="3px"
                        color="white"
                        backgroundColor={ges_colors[ad.energy_ges]}
                        ml={20}
                      >
                        {ad.energy_ges}
                      </Box>
                    </Box>
                  </>
                )}
                {ad.energy_dpe && (
                  <>
                    <Box
                      as="li"
                      className="fz-16"
                      mt={{ sm: 0, xs: 10 }}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      width={{ sm: '50%', xs: '100%' }}
                    >
                      <Box as="span">Diagnostic de performance énergétique (DPE)</Box>
                      <Box
                        as="span"
                        borderRadius={5}
                        color="white"
                        backgroundColor={dpe_colors[ad.energy_dpe]}
                        px={10}
                        py="3px"
                        ml={20}
                      >
                        {ad.energy_dpe}
                      </Box>
                    </Box>
                  </>
                )}
              </Box>

              {dpe_or_ges_is_bad || ad.dpe_infos ? <Box height={30} /> : null}

              {dpe_or_ges_is_bad ? (
                <Box mb={10}>
                  <Text color="negative">Logement à consommation énergétique excessive</Text>
                </Box>
              ) : null}

              {ad.dpe_infos ? (
                <Box>
                  <Text as="strong">Estimation des coûts annuels d’énergie du logement</Text>
                  <Text mt={10}>
                    Montant estimé des dépenses annuelles d’énergie pour un usage standard :
                  </Text>
                  <Text mt={10}>
                    Entre <strong>{ficur(ad.dpe_infos.amounts[0])}</strong> et{' '}
                    <strong>{ficur(ad.dpe_infos.amounts[1])}</strong> par an.
                  </Text>
                  {ad.dpe_infos.years_ref ? (
                    <>
                      {ad.dpe_infos.years_ref.length > 4 ? (
                        <Text color="light">
                          Années de référence des prix de l'énergie utilisées pour établir cette
                          estimation (abonnement compris) : {ad.dpe_infos.years_ref}
                        </Text>
                      ) : (
                        <Text color="light">
                          Année de référence des prix de l'énergie utilisée pour établir cette
                          estimation (abonnement compris) : {ad.dpe_infos.years_ref}
                        </Text>
                      )}
                    </>
                  ) : null}
                </Box>
              ) : null}
            </Box>
          ) : null}

          {(ad.coduminium_charges || ad.coduminium_charges || ad.coduminium_pending_prejudice) && (
            <>
              <Box as="hr" className="w-tiny" />
              <Text as="h3" className="h3-like" mt={30} mb={20}>
                Copropriété
              </Text>
              <Box as="ul" display={{ sm: 'flex', xs: 'block' }} mt={20} lassName="fz-16">
                {ad.coduminium_lots && (
                  <Box as="li" className="fz-16" mt={{ sm: 0, xs: 10 }}>
                    Nombre de lots :
                    <Text as="span" px={10} py="3px" ml={20} className="fz-16" fontWeight={700}>
                      {ad.coduminium_lots}
                    </Text>
                  </Box>
                )}
                {ad.coduminium_charges && (
                  <Box as="li" className="fz-16" mt={{ sm: 0, xs: 10 }}>
                    Charges mensuelles :
                    <Text as="span" px={10} py="3px" ml={20} className="fz-16" fontWeight={700}>
                      {ficur(ad.coduminium_charges)}
                    </Text>
                  </Box>
                )}
                {ad.coduminium_pending_prejudice !== null && (
                  <Box as="li" className="fz-16" mt={{ sm: 0, xs: 10 }}>
                    Procédure en cours :
                    <Text as="span" px={10} py="3px" ml={20} className="fz-16" fontWeight={700}>
                      {!!ad.coduminium_pending_prejudice
                        ? coduminium_pending_prejudice_text[ad.coduminium_pending_prejudice]
                        : ''}
                    </Text>
                  </Box>
                )}
              </Box>

              {ad.coduminum_pending_prejudice_details && (
                <Text mt="5px" className="fz-16" fontWeight={700}>
                  {ad.coduminum_pending_prejudice_details}
                </Text>
              )}
            </>
          )}

          <>
            <Box as="hr" className="w-tiny" />
            <Text as="h3" className="h3-like" mt={30} mb={20}>
              Géorisques
            </Text>
            <Text className="fz-16" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
              Les informations sur les risques auxquels ce bien est exposé sont disponibles sur le
              site Géorisques.{' '}
              <Box
                as="a"
                href="https://www.georisques.gouv.fr"
                target="_blank"
                rel="noopener noreferrer"
                color="n_tertiary"
                display="flex"
                style={{ textDecorationLine: 'underline' }}
              >
                georisques.gouv.fr
              </Box>
            </Text>
          </>

          {!!ad.fees && (
            <>
              <Box as="hr" className="w-tiny" />
              <Text as="h3" className="h3-like" mt={30} mb={20}>
                À propos du prix
              </Text>
              <Box style={{ gap: 5 }} maxWidth={380}>
                {ad.fees.agency && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Frais d'agence :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {fccur(ad.fees.agency * 100)}
                    </Text>
                  </Box>
                )}
                {ad.fees.inventory && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">État des lieux :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {fccur(ad.fees.inventory * 100)}
                    </Text>
                  </Box>
                )}
                {ad.fees.supplement && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Complément de loyer :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {fccur(ad.fees.supplement * 100)}
                    </Text>
                  </Box>
                )}
                {ad.fees.zone_encadrement_loyer !== undefined && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Zone soumise à l'encadrement des loyers :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ad.fees.zone_encadrement_loyer ? 'Oui' : 'Non'}
                    </Text>
                  </Box>
                )}
                {ad.fees.loyer_base !== undefined && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Loyer de base :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ficur(ad.fees.loyer_base)}
                    </Text>
                  </Box>
                )}
                {ad.fees.loyer_reference_majore !== undefined && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Loyer de référence majoré :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ficur(ad.fees.loyer_reference_majore)}
                    </Text>
                  </Box>
                )}
                {ad.fees.modalites_charges_locataire && (
                  <Box display="flex" flexDirection="column" justifyContent="space-between">
                    <Text className="fz-16">Modalités de charges locataire :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ad.fees.modalites_charges_locataire}
                    </Text>
                  </Box>
                )}
                {ad.fees.honorais_charges_de && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Honoraires à la charge de :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ad.fees.honorais_charges_de}
                    </Text>
                  </Box>
                )}
                {!!ad.fees.prix_vente_hors_honoraires && (
                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Text className="fz-16">Prix de vente hors honoraires acquéreur :</Text>
                    <Text className="fz-16" fontWeight={700}>
                      {ficur(ad.fees.prix_vente_hors_honoraires)}
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          )}

          {ad.ad_premium && ad.ad_premium.internal_equipments && (
            <>
              <Text as="h3" className="h3-like" mt={30} mb={20}>
                Équipements
              </Text>

              <Box borderRadius={5} border="1px solid" borderColor="thin" p={30}>
                <BoxFeatures className="fz-16">
                  {choices_internal_equipments
                    .filter(feat => ad.ad_premium.internal_equipments.indexOf(feat.value) !== -1)
                    .map(feat => (
                      <li key={feat.value}>
                        <span>{feat.label}</span>
                        <Check />
                      </li>
                    ))}
                </BoxFeatures>
              </Box>
            </>
          )}

          {ad.ad_premium && ad.ad_premium.charges_mean && ad.ad_premium.charges_including && (
            <>
              <Text as="h3" className="h3-like" mt={30} mb={20}>
                Détail des charges
              </Text>

              <Box borderRadius={5} border="1px solid" borderColor="thin" p={30}>
                <Box as="ul" display={{ sm: 'flex', xs: 'block' }}>
                  <Box
                    as="li"
                    mr={30}
                    className="fz-16"
                    display={{ sm: 'flex', xs: 'block' }}
                    alignItems="center"
                  >
                    <span>Montant</span>
                    <Box
                      as="span"
                      borderRadius={5}
                      border="1px solid"
                      borderColor="thin"
                      px={10}
                      py="3px"
                      ml={20}
                    >
                      {ficur(ad.rent_charges_value)}
                    </Box>
                  </Box>
                  <Box
                    as="li"
                    className="fz-16"
                    mt={{ sm: 0, xs: 10 }}
                    display={{ sm: 'flex', xs: 'block' }}
                    alignItems="center"
                  >
                    <Box as="p">Type de charges</Box>
                    <Box
                      as="p"
                      display="inline-block"
                      borderRadius={5}
                      border="1px solid"
                      borderColor="thin"
                      px={10}
                      py="3px"
                      mt={{ sm: 0, xs: 10 }}
                      ml={{ sm: 20, xs: 0 }}
                    >
                      {ad.ad_premium.charges_mean === 'static'
                        ? 'Forfait'
                        : 'Au réel avec provisions'}
                    </Box>
                  </Box>
                </Box>
                <Text className="fz-16" mt={20}>
                  Inclus dans les charges : <br />
                  {choices_charges_including
                    .filter(feat => ad.ad_premium.charges_including.indexOf(feat.value) !== -1)
                    .map(feat => feat.label)
                    .join(', ')}
                </Text>
              </Box>
            </>
          )}

          {is_premium && <BlockBottomPremium ad={ad} />}

          <Box as="hr" className="w-tiny" />
          <Text as="h3" className="h3-like" mt={30} mb={20}>
            Localisation
          </Text>
          <AdMap ad={ad} />

          {onReport && (
            <Box
              as="button"
              className="btn is-outlined is-medium"
              display={{ md: 'none', xs: 'flex' }}
              width="100%"
              alignItems="center"
              justifyContent="center"
              mt={30}
              onClick={() => set_modal_report_open(true)}
            >
              <SvgIconGarbage />{' '}
              <Box as="span" ml={15}>
                Supprimer cette annonce
              </Box>
            </Box>
          )}
        </Box>

        <Box
          minWidth={{ md: 450, xs: '100%' }}
          maxWidth={{ md: 450, xs: '100%' }}
          position={{ md: 'sticky', xs: 'relative' }}
          alignSelf="flex-start"
          top={{ md: 45, xs: 0 }}
          ml={{ md: 65, xs: 0 }}
          mt={{ md: 0, xs: 0 }}
        >
          <AlertResultContactZone
            linkContact={linkContact}
            nb_contacts={ad.nb_contacts}
            is_premium={is_premium}
            owner_type={ad.owner_type}
            type={(ad.new_real_estate && 'Programme') || ad.type}
            source={ad.source}
            source_label={ad.source_label}
            source_is_subscribed={ad.source_is_subscribed}
            source_has_contact={ad.source_has_contact}
            ad_id={ad.id}
            ad_new_real_estate={ad.new_real_estate}
            expired={Boolean(ad.expired_at)}
            is_favorite={ad.favorite}
            onFavorite={onFavorite}
            onUnfavorite={onUnfavorite}
            free_date={ad.ad_premium && ad.ad_premium.free_date}
            search_type={ad.search_type}
            onClickReport={onReport ? () => set_modal_report_open(true) : undefined}
          />

          {alert && (
            <>
              {Boolean(alert.active) && (
                <Box
                  as={LinkSafe}
                  className="disabled"
                  to={{
                    pathname: routes.alert_unsubscribe.route.reverse(),
                    search: `?token=${alert.id}`
                  }}
                  width="100%"
                  mt={30}
                  display={{ md: 'none', xs: 'none' }}
                  textAlign="center"
                >
                  <SvgIconDisabled />{' '}
                  <Box as="span" ml={10} color="negative" className="fz-20">
                    Désactiver l'alerte
                  </Box>
                </Box>
              )}
            </>
          )}

          {is_premium &&
            ad.ad_premium &&
            ad.ad_premium.display_options &&
            ad.ad_premium.display_options.has_victor_box && (
              <BoxVictor
                display="flex"
                borderRadius={5}
                border="1px solid"
                borderColor="thin"
                p={{ sm: 30, xs: 20 }}
                mt={30}
              >
                <Box
                  as="img"
                  src="https://res.cloudinary.com/loueragile/image/upload/v1574948809/web/landing/Victor.jpg"
                  alt=""
                  className="fls"
                  height={{ sm: '134px', xs: '60px' }}
                  display={{ sm: 'block', xs: 'none' }}
                  mr={30}
                />
                <Box>
                  <Text className="fz-18">
                    <strong>Présenté par Victor</strong>
                  </Text>
                  <Text className="fz-16">
                    Le bien vous plaît ? <br /> Appelez-moi pour planifier rapidement une visite.
                  </Text>
                  <Box
                    display="flex"
                    alignItems="center"
                    color="secondary"
                    mr={30}
                    mt={10}
                    className="fz-18"
                  >
                    <Tel /> <strong>01 76 41 02 67</strong>
                  </Box>
                </Box>
              </BoxVictor>
            )}
          {/* {!is_premium && alert && alert.residenceType !== 'owner' && (
            <Box display="block" textAlign="center" mt={30}>
              <Box
                as="iframe"
                width="100%"
                height="300px"
                frameBorder="0"
                src="https://www.luko.eu/fr/ext/iframe/loueragile-banner"
                title="Banner"
              />
            </Box>
          )} */}
        </Box>
      </Box>
    </>
  )
}

export default React.memo(AlertResultCL)
